import {PAYMENT_CODES} from './payment-codes-enum';

export default function PaymentCodesService() {
    Object.assign(this, {
        getPaymentCodes,
    });

    const SEARCHED_FIELDS = ['organisation', 'project', 'awardCode', 'taskCode'];

    function getPaymentCodes(model) {
        const areNestedArrays = model.every((code) => Array.isArray(code));
        const flattenedModel = areNestedArrays ? getReducedPaymentCodesModel(model) : model;

        const hierarchicalPaymentCodes = getHierarchicalPaymentCodes(angular.copy(flattenedModel));
        const regularCodes = flattenedModel.filter(filterRegularCodes);
        const specialCodes = flattenedModel.filter(filterSpecialCodes);
        const formattedSpecialCodes = getFormattedSpecialCodes(specialCodes);
        const regularFormattedCodes = _.compact(_.map(regularCodes, getFormatted));
        return [...hierarchicalPaymentCodes, ...regularFormattedCodes, ...formattedSpecialCodes];

        function getFormattedSpecialCodes(codes) {
            if (!codes) {
                return [];
            }
            const flattened = codes.reduce((acc, value) => ([...acc, ...value]), []);
            const [maskDropdown1, maskDropdown2] = flattened.filter((code) => code.PaymentCodeFieldTypeId === PAYMENT_CODES.MASK_DROPDOWN);
            const [dropdownMask1, dropdownMask2] = flattened.filter((code) => code.PaymentCodeFieldTypeId === PAYMENT_CODES.DROPDOWN_MASK);
            const result = [];
            if (maskDropdown1 && maskDropdown2) {
                result.push({
                    Id: maskDropdown1.Id,
                    CodeValue: `${maskDropdown1.value} ${getValue(maskDropdown2)}`,
                });
            }
            if (dropdownMask1 && dropdownMask2) {
                result.push({
                    Id: dropdownMask1.Id,
                    CodeValue: `${getValue(dropdownMask1)} ${dropdownMask2.value}`,
                });
            }

            function getValue(dropdown) {
                return angular.isObject(dropdown.value.value) && dropdown.value.value.hasOwnProperty('Value')
                    ? dropdown.value.value.Value
                    : dropdown.value.value;
            }

            return result;
        }

        function filterRegularCodes(code) {
            return code.PaymentCodeFieldTypeId !== PAYMENT_CODES.HIERARCHICAL_CODES
                && !Array.isArray(code);
        }

        function filterSpecialCodes(code) {
            return Array.isArray(code);
        }

        function getFormatted(code) {
            let codeValue;
            switch (code.PaymentCodeFieldTypeId) {
                case PAYMENT_CODES.PREDEFINED_DROPDOWN:
                    codeValue = (code.isDropdown) ? code.value.value : code.Value;
                    break;
                case PAYMENT_CODES.MASK_DROPDOWN:
                    codeValue = code[0] + code[1].value.value.Value;
                    break;
                case PAYMENT_CODES.DROPDOWN_MASK:
                    codeValue = code[0].value.value.Value + code[1];
                    break;
                default:
                    codeValue = code.value;
                    break;
            }

            return codeValue
                ? {Id: code.Id,
                    CodeValue: codeValue,
                    travellerId: code.travellerId,
                    mask: getMask(code)}
                : null;
        }

        function getMask(code) {
            if (angular.isArray(code)) {
                return angular.isString(code[1]) ? code[1] : code[0];
            }
            return null;
        }
    }

    function getHierarchicalPaymentCodes(model) {
        if (!model || !Array.isArray(model)) {
            return [];
        }
        const hierarchicalCodes = model
            .filter((item) => item.PaymentCodeFieldTypeId === PAYMENT_CODES.HIERARCHICAL_CODES)
            .map((code) => {
                const travellerId = code.travellerId;
                return Object.keys(code)
                    .filter((key) => SEARCHED_FIELDS.includes(key))
                    .map((key) => (code[key]))
                    .map(({Id, Value: CodeValue, SelectedValueId: CodeValueId}) => {
                        const newCode = {Id, CodeValue, CodeValueId};
                        return Object.assign(newCode, travellerId ? {travellerId} : {});
                    });
            });


        for (const num in hierarchicalCodes) {
            hierarchicalCodes[num] = hierarchicalCodes[num].filter((el) => !!el.Id);
        }

        const flattenedCodes = hierarchicalCodes
            .reduce((acc, code) => [...acc, ...code], []);

        return hierarchicalCodes
            ? flattenedCodes
            : [];
    }

    function getReducedPaymentCodesModel(modelPerTraveller) {
        return modelPerTraveller.reduce((acc, model) => {
            return [...acc, ...model];
        }, []);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-service.js